/**
 * Boards selectors
 */

import { RootState } from "types";

import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./initialState";

// TODO: Add an explanation for this
const selectDomain = (state: RootState) => state?.boardSetting || initialState;

export const selectIsBoardLoading = createSelector(
  [selectDomain],
  (state) => state.isBoardLoading
);
export const selectIsBoardCreate = createSelector(
  [selectDomain],
  (state) => state.isBoardCreate
);
export const selectBoardForm = createSelector(
  [selectDomain],
  (state) => state.boardForm
);
export const selectDraftBoardForm = createSelector(
  [selectDomain],
  (state) => state.draftBoardForm
);
